import type { paths } from "../types/fulfilment-api.generated";
import * as api from "./client";

// ============================================================================
// Type Definitions from Generated API Types
// ============================================================================

// Extract types from OpenAPI generated types
type FeaturesListResponse =
  paths["/api/v1/features"]["get"]["responses"]["200"]["content"]["application/json"];

type FeatureDetailResponse =
  paths["/api/v1/features/{code}"]["get"]["responses"]["200"]["content"]["application/json"];

// Export the Feature type from the list response
export type Feature = FeaturesListResponse["features"][number];

export type AnalyzeFeaturesResult = {
  required_entity_fields: string[];
  field_metadata: Record<string, { label: string; help_text: string }>;
  requestId?: string | null;
};

// Export query parameter types
export type FeatureQueryParams = paths["/api/v1/features"]["get"]["parameters"]["query"];

// ============================================================================
// Service
// ============================================================================

export const featuresService = {
  /**
   * Get all features with optional filtering
   */
  async get(params?: FeatureQueryParams): Promise<FeaturesListResponse> {
    const queryParams = new URLSearchParams();

    if (params?.type) queryParams.append("type", params.type);
    if (params?.scope !== undefined) {
      queryParams.append("scope", String(params.scope));
    }
    if (params?.status) queryParams.append("status", params.status);
    if (params?.pageType) queryParams.append("pageType", params.pageType);
    if (params?.site) queryParams.append("site", params.site);
    if (params?.language) queryParams.append("language", params.language);

    const queryString = queryParams.toString();
    const endpoint = `/v1/fulfilment/features${queryString ? `?${queryString}` : ""}`;

    return api.get<FeaturesListResponse>(endpoint);
  },

  /**
   * Get a single feature by code
   */
  async getByCode(code: string): Promise<FeatureDetailResponse> {
    return api.get<FeatureDetailResponse>(`/v1/fulfilment/features/${code}`);
  },

  /**
   * Analyze features to determine required metadata fields
   */
  async analyzeFeatures(featureCodes: string[]): Promise<AnalyzeFeaturesResult> {
    const queryParams = new URLSearchParams();
    queryParams.append("feature_codes", featureCodes.join(","));

    return api.get<AnalyzeFeaturesResult>(
      `/v1/fulfilment/features/analyze?${queryParams.toString()}`,
    );
  },
};
